// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ISF1","label":"SetPasswdForm_label__2Fgqi"};